import { gql } from 'apollo-angular';
import { paginationFragment } from '@services/queries/fragments/lighthouse.fragments';

export const teamsQuery = gql`
  query Teams(
    $page: Int
    $size: Int!
    $where: QueryTeamsWhereWhereConditions
    $orderBy: [QueryTeamsOrderByOrderByClause!]
  ) {
    teams(page: $page, first: $size, where: $where, orderBy: $orderBy) {
      data {
        id
        name
      }
      paginatorInfo {
        ...PaginationFragment
      }
    }
  }
  ${paginationFragment}
`;
